<div class="home-hero-banner d-flex align-items-center">
  <div class="container">
    <div class="text-white hero-text">
      CREATING<br/>
      DIFFERENCE<br/>
      SINCE 1972
    </div>
  </div>
</div>
<div class="container text-dark mb-5">
  <div class="row mt-5">
    <div class="col-7">
      <img src="assets/images/mission.jpg" alt="mission-image" class="w-100 pr-4"/>
    </div>
    <div class=" col-5 d-flex align-items-center">
      <div>
        <h1>Mission</h1>
        <p>Sustainable Growth to secure the future by providing the best Products and Services required by our customers
          delivering value for money matching the world's best in terms of Technology, Production, Quality and
          Delivery.</p>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class=" col-5 d-flex align-items-center">
      <div>
        <h1>Vision</h1>
        <p>Having its beginning since 1972 the company resolved to be the best at what it does moving forward with
          changing
          times, adapting itself with improving Technology and Changing Needs.</p>
      </div>
    </div>
    <div class="col-7">
      <img src="assets/images/vision.jpg" alt="vission-image" class="w-100 pl-4"/>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-7">
      <img src="assets/images/values.jpg" alt="values-image" class="w-100 pr-4"/>
    </div>
    <div class=" col-5 d-flex align-items-center">
      <div>
        <h1>Values</h1>
        <p>Building Lifetime relationships with all of the companies stakeholders. Creating an atmosphere of trust,
          innovation and teamwork.</p>
      </div>
    </div>
  </div>
</div>
